module.exports = __webpack_public_path__ + "img/abl_moto.c153f029.png";